module.exports = __webpack_public_path__ + "static/img/84.d78f121.png";